// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__2RUIF","title":"AfterFrontImage_title__ucu30"};